import { ChangeEventHandler, FC } from "react";

import HiddenFileInput from "./styles/HiddenFileInput";
import StyledSelectFileButtonButton from "./styles/StyledSelectFileButton";

interface SelectFileButtonProps {
  label: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClick?: () => void;
  primary?: boolean;
}

const SelectFileButton: FC<SelectFileButtonProps> = ({
  label,
  onChange,
  onClick,
  primary,
}) => {
  return (
    <StyledSelectFileButtonButton primary={primary}>
      <HiddenFileInput
        onChange={onChange}
        onClick={onClick}
        accept="image/png, image/gif, image/jpeg, image/bmp, application/pdf"
      />
      {label}
    </StyledSelectFileButtonButton>
  );
};

export default SelectFileButton;
